<script setup>
import { ref } from "vue";
import { StealieLogo } from "@get-overalls/fe-stealie";
import InitialsAvatar from "@/components/InitialsAvatar.vue";
import { useNavigation } from "@/composables/useNavigation";
import UserProfileMenu from "@/components/layout/UserProfileMenu.vue";

const { user, company } = useNavigation();
const isMenuOpen = ref(false);
</script>

<template>
  <header
    class="sticky top-0 z-10 shrink-0 bg-white px-4 shadow-[0px_4px_8px_0px_rgba(10,92,94,0.08)] lg:hidden"
  >
    <div class="flex h-16 items-center">
      <RouterLink :to="{ name: 'Dashboard' }" class="mr-auto">
        <StealieLogo class="-ml-2 h-7" />
      </RouterLink>
      <div>
        <button
          v-if="user.initials"
          class="p-2 text-white"
          :aria-expanded="isMenuOpen"
          aria-haspopup="true"
          :aria-description="`Open user menu for ${user.fullName}`"
          @click="isMenuOpen = true"
        >
          <InitialsAvatar :initials="user.initials" />
        </button>
        <UserProfileMenu v-model:open="isMenuOpen" :user="user" :company="company" />
      </div>
    </div>
    <div>
      <slot />
    </div>
  </header>
</template>
